import React, { useState, useEffect, useContext, useRef } from "react";
import { useParams } from "react-router-dom";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import FormControlLabel from "@mui/material/FormControlLabel";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import { EDIT_GROUP_MUTATION, GET_GROUP_DATA_BY_NAME, GET_GROUP_DATA_BY_ID } from "../../graphQL/group_qry";
import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY  } from "../../graphQL/user_qry";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({

  textFieldInput: {  
       
    height: "150px",
    maxHeight: "200px",
    width: "400px",
    resize: "both",
    
  },

  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    width: "100%",
    "& .super-app-theme--header": {
      backgroundColor: "#99D4FF",//"#0D47A1",
      color: "#0D47A1",
      fontSize: 18,
      fontWeight: 700,
    },
    "& .MuiDataGrid-cell": {
      fontSize: 16,
      fontWeight: 400,
    },
    "& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-row.Mui-selected": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-row:hover": {
      backgroundColor: "none !important",
    },
    "& .MuiDataGrid-cell:focus-within": {
      outline: " none !important",
    },
    [`& .${gridClasses.row}.even`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd`]: {
      backgroundColor: "#E3F2FD",
    },
    [`& .${gridClasses.row}.even:hover`]: {
      backgroundColor: "#FFFFFF",
    },
    [`& .${gridClasses.row}.odd:hover`]: {
      backgroundColor: "#E3F2FD",
    },
    [`& .${gridClasses.row}.even.Mui-selected`]: {
      backgroundColor: "#FFFFFF !important",
    },
    [`& .${gridClasses.row}.odd.Mui-selected`]: {
      backgroundColor: "#E3F2FD !important",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  datePickerStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
}));

function GroupDetail() {
  const { groupUuid } = useParams();

  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);

  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const classes = useStyles();
  const [errorMsg, setErrorMsg] = useState({
    groupName: "",
    
  });
  
  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [editAccess, setEditAccess] = useState(true);
  
  const [groupName, setGroupName] = useState("");
  const [desc, setDesc] = useState("");
  
  const [alertMsg, setAlertMsg] = useState([]);
  const [groupData, setGroupData] = useState([]);

  const [remainedChars, setRemainedChars] = useState(254);
  

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [getGroupData] = useManualQuery(GET_GROUP_DATA_BY_ID, {
    fetchPolicy: "network-only",
  });

  const [getGroupDataByName] = useManualQuery(GET_GROUP_DATA_BY_NAME, {
    fetchPolicy: "network-only",
  });

  const [editGroup] = useMutation(EDIT_GROUP_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "General Settings",
              modulepageName: "Manage Groups"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {  
        
            
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      
      
      if(commonActions.find(a => a == "Edit")){
        setEditAccess(true);}
      else { setEditAccess(false);}


      
    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);


    

  const getGroup = async () => {
    
    if (groupUuid) {
      // Get group information
      const {
        loading: groupDataLoading,
        error: groupDataError,
        data: groupData,
      } = await getGroupData({
        variables: { groupUuid: groupUuid },
      });

      if (groupData.getGroupDataById == null)
      {
        navigate(`${project_url}/tenant/dashboard`)
      }

      if (!groupDataLoading && groupData && groupData.getGroupDataById) {
        setGroupData(groupData.getGroupDataById);        
        setGroupName(groupData.getGroupDataById.name); 
        setDesc(groupData.getGroupDataById.desc);
        if (groupData.getGroupDataById.desc)
          setRemainedChars(254 - groupData.getGroupDataById.desc.length)
                          
        
      }
      if (
        groupDataError &&
        groupDataError.graphQLErrors &&
        groupDataError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };

  
  const handleGroupNameChange = e => {
    setGroupName(e.target.value);
  };
  
  const handleDescChange = e => {
    setDesc(e.target.value);
    setRemainedChars(254 - e.target.value.length)
  };

    
  useEffect(() => {

    (() => getGroup())();
  }, []);

  
  const onSubmit = async formData => {
    
    //check if entered name exist in client or not
    const {
      loading: groupLoading,
      error: groupError,
      data: groupData,
    } = await getGroupDataByName(
      {
        variables: { 
          name: formData.groupName, 
          clientId: parseInt(clientId) , 
          groupUuid: groupUuid},
      });

    if (!groupLoading && groupData && groupData.getGroupDataByName){
      setErrorMsg(
        { groupName: "Group Name already exists for the client. Please enter another name" }
      );
    }
    else {
      setErrorMsg({});
      const { data, error } = await editGroup({
        variables: {
          name: formData.groupName,
          groupUuid: groupUuid,
          desc: formData.desc
           },
          });
      if (error) {
        console.log("Error", error, data);
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
             });
        } 
      else if (data && data.editGroup) {
        console.log("Success", data);
        setAlertMsg({
          title: "Success",
          msg: "Group has been successfully updated.",
        });
        navigate(`${project_url}/groups`)
      }
    }
  };
  
  if (loadContent)
    if (editAccess)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: groupData.name, link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginBottom: 10 }}>
              Groups Edit
            </Typography>
          </Box>
          <Divider />

          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid container spacing={3} style={{ marginTop: 30 }}>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  autoFocus
                  fullWidth
                  label="Group Name"
                  margin="normal"
                  name="groupName"
                  type="groupName"
                  variant="outlined"
                  value={groupName}
                  id="groupName"
                  {...register("groupName", { required: true })}
                  onChange={handleGroupNameChange}
                />

                {errors.groupName && errors.groupName.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Group Name cannot be blank.
                  </FormHelperText>
                )}

                {errorMsg.groupName && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.groupName}
                  </FormHelperText>
                )} 

                <TextField
                  className={classes.textFieldStyle}
                  multiline
                  rows={6}
                  label="Description"
                  margin="normal"
                  name="desc"                  
                  variant="outlined"
                  id="desc"
                  {...register("desc")}
                  inputProps={{
                    maxLength: 254,
                  }}
                  InputProps={{
                      classes: {
                         input: classes.textFieldInput
                      },
                    }}                
                  value={desc}                  
                  onChange={handleDescChange}
                /> 

                <Typography
                  variant="h6"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    paddingRight: 5,
                    paddingTop: 5,
                    color: "#00000099",
                  }}
                >
                  {remainedChars}  of 254 Characters left
                                    
                </Typography>  

                
              </Grid>
            </Grid>
              

            <Box pt={4} pb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                type="submit"
              >
                Save
              </Button>

              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={() => navigate(`${project_url}/groups`)}
              >
                Cancel
              </Button>
            </Box>
          </form>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
                alertMsg.title === "Success" && navigate(`${project_url}/groups`);
              }}
            />
          )}
        </div>
      </div>
    );
  
  else
    return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );
  else return;
}

export default GroupDetail;
